module.exports = __webpack_public_path__ + "static/img/Biometric Identification.1d26528.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/Biometric Identification.jpg
// module id = 8GLu
// module chunks = 1